// Query editor — execute queries and display results
import { api } from './api.js';

let _connectionId = null;
let _lastResult = null;

export function setConnection(id) { _connectionId = id; }

export function init() {
  const input = document.getElementById('query-input');
  const status = document.getElementById('query-status');

  document.getElementById('btn-run-query').addEventListener('click', () => runQuery());
  document.getElementById('btn-clear-query').addEventListener('click', () => {
    input.value = '';
    clearResults();
  });

  // Ctrl+Enter / F5 to run
  input.addEventListener('keydown', e => {
    if ((e.ctrlKey && e.key === 'Enter') || e.key === 'F5') {
      e.preventDefault();
      runQuery();
    }
    // Tab inserts spaces
    if (e.key === 'Tab') {
      e.preventDefault();
      const s = input.selectionStart;
      input.value = input.value.substring(0, s) + '  ' + input.value.substring(input.selectionEnd);
      input.selectionStart = input.selectionEnd = s + 2;
    }
  });

  document.querySelectorAll('.rtab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.rtab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.results-view').forEach(v => v.classList.remove('active'));
      tab.classList.add('active');
      document.getElementById('results-' + tab.dataset.rt).classList.add('active');
    });
  });

  document.getElementById('btn-export-results').addEventListener('click', exportResults);
}

async function runQuery() {
  const input = document.getElementById('query-input');
  const query = input.value.trim();
  if (!query) return;

  const status = document.getElementById('query-status');
  const btn = document.getElementById('btn-run-query');
  btn.disabled = true;
  status.textContent = 'Executing...';
  addMessage('Executing query...', 'info');

  const t0 = performance.now();
  try {
    const res = await api.execute(_connectionId, query);
    const ms = (performance.now() - t0).toFixed(1);
    status.textContent = ms + ' ms';

    if (res.success && res.data) {
      _lastResult = res.data;
      renderTable(res.data);
      renderJson(res.data);
      document.getElementById('result-time').textContent = ms + ' ms';
      addMessage('Query completed in ' + ms + ' ms', 'success');
    } else {
      addMessage(res.error || 'Query failed', 'error');
      document.getElementById('result-rows').textContent = '0 rows';
    }
  } catch (err) {
    status.textContent = 'Error';
    addMessage('Connection error: ' + err.message, 'error');
  } finally {
    btn.disabled = false;
  }
}

function renderTable(data) {
  const table = document.getElementById('r-table');
  const cols = data.columns || [];
  const rows = data.rows || [];

  let h = '<thead><tr>' + cols.map(c => '<th>' + esc(c) + '</th>').join('') + '</tr></thead>';
  h += '<tbody>';
  for (const row of rows) {
    h += '<tr>' + row.map(v => '<td>' + esc(String(v ?? '')) + '</td>').join('') + '</tr>';
  }
  h += '</tbody>';
  table.innerHTML = h;

  const empty = table.parentElement.querySelector('.results-empty');
  if (empty) empty.style.display = rows.length ? 'none' : '';
  document.getElementById('result-rows').textContent = rows.length + ' rows';
}

function renderJson(data) {
  document.getElementById('r-json').textContent = JSON.stringify(data, null, 2);
}

function addMessage(text, type = 'info') {
  const el = document.getElementById('r-messages');
  const div = document.createElement('div');
  div.className = 'msg msg-' + type;
  div.textContent = '[' + new Date().toLocaleTimeString() + '] ' + text;
  el.appendChild(div);
  el.scrollTop = el.scrollHeight;
}

function clearResults() {
  _lastResult = null;
  document.getElementById('r-table').innerHTML = '<thead></thead><tbody></tbody>';
  document.getElementById('r-json').textContent = '';
  document.getElementById('result-rows').textContent = '0 rows';
  document.getElementById('result-time').textContent = '';
  const empty = document.querySelector('.results-empty');
  if (empty) empty.style.display = '';
}

function exportResults() {
  if (!_lastResult || !_lastResult.rows?.length) return;
  const cols = _lastResult.columns || [];
  const rows = _lastResult.rows || [];
  let csv = cols.join(',') + '\n';
  for (const row of rows) csv += row.map(v => '"' + String(v ?? '').replace(/"/g, '""') + '"').join(',') + '\n';
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
  a.download = 'gdbs_query_results.csv';
  a.click();
}

function esc(s) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
